import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type TrackNewOrderCb_Type = () => void; // TurnToCmd(...) - https://docs.emplifi.io/platform/latest/home/javascript-order-feed

interface State {
  emplifiTrackNewOrderCb: TrackNewOrderCb_Type | null;
  setEmplifiTrackNewOrderCb: (value: TrackNewOrderCb_Type) => void;
}

const _useEmplifiTrackNewOrderCbStore = create<State>(set => ({
  emplifiTrackNewOrderCb: null,
  setEmplifiTrackNewOrderCb: value => set({ emplifiTrackNewOrderCb: value }),
}));

// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
export const useEmplifiTrackNewOrderCbStore = () => {
  const { emplifiTrackNewOrderCb, setEmplifiTrackNewOrderCb } =
    _useEmplifiTrackNewOrderCbStore(
      useShallow(state => ({
        emplifiTrackNewOrderCb: state.emplifiTrackNewOrderCb,
        setEmplifiTrackNewOrderCb: state.setEmplifiTrackNewOrderCb,
      }))
    );

  return { emplifiTrackNewOrderCb, setEmplifiTrackNewOrderCb };
};

// ─── Usage ───────────────────────────────────────────────────────────────────
//
// const { emplifiTrackNewOrderCb, setEmplifiTrackNewOrderCb } = useEmplifiTrackNewOrderCbStore();
//
// if (!emplifiTrackNewOrderCb) {
//   setEmplifiTrackNewOrderCb(() => { console.log("test"); });
// } else {
//   emplifiTrackNewOrderCb();
// }
//
// ─────────────────────────────────────────────────────────────────────────────
